export default __webpack_public_path__ + "static/media/530.e518a052.png";